import { Component, OnInit } from '@angular/core';
import { NavigationEnd, Router } from '@angular/router';
import { LocalStorageService } from 'src/app/shared/services/angular-service/local-storage.service';
import { SeoService } from 'src/app/shared/services/angular-service/seo.service';

@Component({
  selector: 'app-profile-page',
  templateUrl: './profile-page.component.html',
  styleUrls: ['./profile-page.component.scss'],
})
export class ProfilePageComponent implements OnInit {
  changePasswordFlag: boolean = false;
  urlPosition: any = '';
  deviceType: any;

  constructor(
    private router : Router,
    private seoService: SeoService,
    private localStorageService : LocalStorageService
  ) {
    this.deviceType = localStorageService.getItem('deviceType');
    this.router.events.subscribe(event => {
      if (event instanceof NavigationEnd) {
        this.changePasswordFlag = this.router.url.includes('change-password');
        this.urlPosition = this.router.url;
      }
    });
  }

  ngOnInit(): void {
    this.seoService.getSeo('account');
  }
}
